import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=6ff0c4d7&scoped=true&"
import script from "./contents.ts?vue&type=script&lang=ts&"
export * from "./contents.ts?vue&type=script&lang=ts&"
import style0 from "./contents.scss?vue&type=style&index=0&id=6ff0c4d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0c4d7",
  null
  
)

export default component.exports